import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

const periodResponseFields = {
  id: true,
  name: true,
  periodType: true,
  startDate: true,
  endDate: true,
  status: true,
  facilityId: true,
  closedAt: true,
  closedBy: true,
  lockedAt: true,
  lockedBy: true,
  unlockReason: true,
  unlockExpiresAt: true,
  notes: true,
  timestamps: {
    createdAt: true,
    updatedAt: true,
  },
} as const;

export const lockInventoryPeriodAtom = createMutationAtomFactory(
  'inventory.lockInventoryPeriod',
  (params: { id: string }) => ({
    inventoryInventoryPeriodLock: {
      __args: {
        id: params.id,
      },
      ...periodResponseFields,
    },
  }),
);

export const unlockInventoryPeriodAtom = createMutationAtomFactory(
  'inventory.unlockInventoryPeriod',
  (params: { id: string; reason: string; expiresAt?: string }) => ({
    inventoryInventoryPeriodUnlock: {
      __args: {
        id: params.id,
        reason: params.reason,
        expiresAt: params.expiresAt,
      },
      ...periodResponseFields,
    },
  }),
);

export const archiveInventoryPeriodAtom = createMutationAtomFactory(
  'inventory.archiveInventoryPeriod',
  (params: { id: string }) => ({
    inventoryInventoryPeriodArchive: {
      __args: {
        id: params.id,
      },
      ...periodResponseFields,
    },
  }),
);
